import backend from './backend';

const endpoint = '/customers';

export default {
    get(){
        return backend.get(endpoint).then(response => response.data)
    },
}
